// GAVION commissions in the app: the shared twin (supabase/functions/_shared/gavion/commissions.ts) plus display helpers.
import {
  DEFAULT_ANNUAL_DISCOUNT_PCT,
  monthStart,
} from "../../../../../supabase/functions/_shared/gavion/commissions.ts";
import { torontoDate } from "../time/toronto";

export * from "../../../../../supabase/functions/_shared/gavion/commissions.ts";

const money = new Intl.NumberFormat("fr-CA", {
  style: "currency",
  currency: "CAD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const pct = new Intl.NumberFormat("fr-CA", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** « 24,90 $ » (cents shown, unlike formatCad). */
export const formatMoney = (n: number | null | undefined): string =>
  n == null ? "—" : money.format(n);
/** « 10 % », « 12,5 % ». */
export const formatPct = (n: number | null | undefined): string =>
  n == null ? "—" : `${pct.format(n)} %`;
/** The current month in America/Toronto (YYYY-MM-01). */
export const currentMonth = (now: Date = new Date()): string =>
  monthStart(torontoDate(now));
/** configuration.config.gavion.billing.annual_discount_pct, else 15 (private.annual_discount_pct). */
export const annualDiscountPctOf = (config: unknown): number => {
  const v = (
    config as
      | { gavion?: { billing?: { annual_discount_pct?: unknown } } }
      | null
      | undefined
  )?.gavion?.billing?.annual_discount_pct;
  return typeof v === "number" ? v : DEFAULT_ANNUAL_DISCOUNT_PCT;
};
